import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, SkipForward } from "lucide-react";

// Pre-roll video AD placeholder shown to free users before the film starts.
export const VideoAdPlaceholder = ({ onFinish }) => {
  const [count, setCount] = useState(5);

  useEffect(() => {
    if (count <= 0) return;
    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [count]);

  return (
    <div className="relative w-full aspect-video bg-black overflow-hidden flex items-center justify-center" data-testid="video-ad">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(0,240,255,0.12),transparent_55%)]" />
      <div className="relative text-center px-6">
        <span className="font-mono-ui text-[10px] tracking-widest px-2 py-0.5 rounded border border-white/20 text-white/60">VIDEO AD</span>
        <div className="mt-5 mx-auto w-16 h-16 rounded-2xl bg-[#00F0FF]/10 border border-[#00F0FF]/30 flex items-center justify-center">
          <Sparkles size={30} className="text-[#00F0FF]" />
        </div>
        <h3 className="mt-5 font-heading text-xl sm:text-2xl font-bold text-white">Advertisement</h3>
        <p className="mt-2 text-sm text-white/50 max-w-sm mx-auto">Your film starts right after this short break. Go Premium to skip ads forever.</p>
        <div className="mt-6 flex items-center justify-center gap-3">
          {count > 0 ? (
            <span className="text-sm text-white/60" data-testid="ad-countdown">Skip in {count}s</span>
          ) : (
            <button onClick={onFinish} data-testid="ad-skip-btn" className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-medium px-5 py-2 hover:bg-white/20 transition-colors">
              <SkipForward size={16} /> Skip Ad
            </button>
          )}
          <Link to="/premium" data-testid="ad-premium-link" className="rounded-full bg-[#00F0FF] text-black text-sm font-semibold px-5 py-2 hover:scale-105 transition-transform">
            Remove Ads — $3.99/mo
          </Link>
        </div>
      </div>
    </div>
  );
};
